
import { useEffect, useState } from 'react';

interface Particle {
  id: number;
  x: number;
  size: number;
  duration: number;
  delay: number;
  color: string;
}

export default function ParticleBackground() {
  const [particles, setParticles] = useState<Particle[]>([]);

  useEffect(() => {
    try {
      const colors = ['#14b8a6', '#a855f7', '#ec4899', '#38bdf8', '#facc15'];

      // Guard against an empty colors array (should never happen but adds safety)
      if (!colors.length) {
        throw new Error('Color palette is empty.');
      }

      const generated: Particle[] = Array.from({ length: 20 }, (_, i) => ({
        id: i,
        x: Math.random() * 100,
        size: Math.random() * 4 + 2,
        duration: Math.random() * 8 + 6,
        delay: Math.random() * 5,
        color: colors[Math.floor(Math.random() * colors.length)],
      }));

      setParticles(generated);
    } catch (error) {
      // In production you might want to report this error to a monitoring service
      console.error('Failed to generate particles:', error);
      setParticles([]); // Ensure the component remains stable
    }
  }, []);

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {particles.map((p) => (
        <div
          key={p.id}
          className="particle"
          style={{
            position: 'absolute',
            left: `${p.x}%`,
            bottom: '-10px',
            width: `${p.size}px`,
            height: `${p.size}px`,
            backgroundColor: p.color,
            borderRadius: '50%',
            animationName: 'float',
            animationDuration: `${p.duration}s`,
            animationDelay: `${p.delay}s`,
            animationTimingFunction: 'ease-out',
            animationIterationCount: 'infinite',
            boxShadow: `0 0 ${p.size * 3}px ${p.color}`,
          }}
        />
      ))}
    </div>
  );
}
